export const s3DOConfig = {
  endpoint: import.meta.env.VITE_AWS_DO_ENDPOINT,
  // endpoint: import.meta.env.VITE_AWS_DO_DIR_NAME,
  accessKeyId: import.meta.env.VITE_AWS_DO_KEY_ID,
  secretAccessKey: import.meta.env.VITE_AWS_DO_ACCESS_KEY,
  region: 'fra1',
  bucketName: import.meta.env.VITE_AWS_DO_BUCKET,
};
